<template>
  <div class="titArea" v-show="showHader">
    <h1>{{title}}</h1>
    <!-- <span>{{ $route.name }}</span> -->
    <slot></slot>
    <button type="button" class="btnPre" v-if="exposure" @click="$router.go(-1);">이전으로</button>
    <!-- <button type="button" class="btnHome">홈으로</button> -->
  </div>
</template>
<script>

import Const from '../helpers/Const';
import ConstTerms from '../helpers/ConstTerms';

export default {
  computed: {
    exposure() {
      return [
        'SubscListItem',
        'SubscRevoke',
        'GuideTotal',
        'TermInfo',
      ].includes(this.$route.name);
    },

    title(){
      var title = "BMW ServiceCare+";
      if(typeof this.$route.meta.titleType != 'undefined') {
        switch(this.$route.meta.titleType) {
          case Const.HEADER_TITLE.APPLY: title = 'BMW ServiceCare+ 구독 신청'; break;
          case Const.HEADER_TITLE.MY: title = 'ServiceCare+'; break;
          case Const.HEADER_TITLE.SHOT: title = 'ServiceCare+'; break;
          case Const.HEADER_TITLE.TERM:
            if(typeof ConstTerms.getTermsTitle()[this.$route.params.type] != 'undefined' ) 
              title = ConstTerms.getTermsTitle()[this.$route.params.type];
            break;
          default: title = this.$route.meta.titleType; break;
        }
      }

      return title;
    },

    showHader(){
      let isShow = true;

      if(typeof this.$route.meta.titleType == 'undefined' 
        || this.$route.meta.titleType == '') {
        isShow = false;
      } else {
        isShow = !this.$route.meta.notContentTitle;
      }

      return isShow;
    },
  },
}
</script>